import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import ChangeSubscriptionSkeleton from './changeSubscriptionSkeleton';

import {
  getMarquetItems,
  getCustomerSubscriptionById,
  selectSubscription,
  getPlanDetails
} from "../../../store/actions";
import { getCustomer } from '../../../utils/helpers';

import { useScreenSize } from '../../../hooks/ScreenSize';

import CheckIcon from '../../../assets/svg/checkIcon';

const SubscriptionUpgrade = () => {

  const customerId = getCustomer();
  const param = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const chageSubscription = useSelector((state) => state.changeSubscription);

  const screenSize = useScreenSize();

  useEffect(() => {
    if (customerId === "") {
      navigate('/')
    }
  }, [])

  useEffect(()=>{
    if (chageSubscription.currencyCode === "" && chageSubscription.period === ""){
      dispatch(getCustomerSubscriptionById(param.subscriptionId));
    }
  }, [])

  useEffect(() => {
    if (!chageSubscription.plansObtained && chageSubscription.currencyCode !== "" && chageSubscription.period !== ""){
      dispatch(getMarquetItems({ currencyCode: chageSubscription.currencyCode, period: chageSubscription.period }));
    }
  }, [chageSubscription.plansObtained || chageSubscription.currencyCode || chageSubscription.period ])

  useEffect(()=>{
    if (chageSubscription.plansObtained && chageSubscription.NumberOfplansDetailsObtained === 0){
      chageSubscription.plans.map((it)=>{
        dispatch(getPlanDetails(it.itemId));
      })
    }
  }, [chageSubscription.plansDetailsObtained || chageSubscription.plansObtained])

  const changeSubscription = (subscription) => {
    dispatch(selectSubscription(subscription));
    navigate(`/mySubscription/${param.subscriptionId}`);
  }

  function adjustHeight(){
    if (chageSubscription.loadedFirstTime && screenSize > 400) {
      setTimeout(() => {
        const cards = document.querySelectorAll('.plan--info');
        let maxHeigth = 0;
        cards.forEach((card) => {
          maxHeigth = Math.max(card.getBoundingClientRect().height, maxHeigth);
        })
        cards.forEach((card) => {
          card.style.height = `${maxHeigth}px`;
        })
      }, 200)
    } else if (screenSize <= 400) {
      setTimeout(() => {
        const cards = document.querySelectorAll('.plan--info');
        cards.forEach((card) => {
          card.style.height = 'auto'
        })
      }, 200)
    }
  }

  if (!chageSubscription.loadedFirstTime) {
    return (
      <ChangeSubscriptionSkeleton />
    )
  }

  return (
    <>
      <div className="change--subscription">
        {chageSubscription && chageSubscription.plans && chageSubscription.plans.length > 0 &&
          chageSubscription.plans.map((it, i) => {
            if (it.itemType === "plan" && it.price > 0){
              return(
                <div key={i} className="plan--card">
                  <div className="plan--info">
                    <div className="plan--img" style={it.metadata && it.metadata.img ? {display:"flex"} : {display:"none"}}>
                      <img src={it.metadata && it.metadata.img ? it.metadata.img:""} onLoad={ev => {adjustHeight()}}/>
                    </div>
                    <div className="main--features">
                      <h2>
                        {`${it.itemId}`}
                      </h2>
                      <div>
                        {it.metadata && it.metadata.basicFeatures && it.metadata.basicFeatures.length > 0 &&
                          it.metadata.basicFeatures.map((jt, j) => (
                            <p key={j}>{jt}</p>
                          ))
                        }
                      </div>
                    </div>
                    <div className="button--row">
                      <button
                        className="custom--button"
                        onClick={ev => changeSubscription(it)}
                        >
                        Select
                      </button>
                    </div>
                  </div>
                  <div className="plan--features">
                    {it.metadata && it.metadata.allFeatures && it.metadata.allFeatures.length > 0 &&
                      it.metadata.allFeatures.map((kt, k) => (
                        <div key={k}>
                          <CheckIcon /> <div>{kt}</div>
                        </div>
                      ))
                    }
                  </div>
                </div>
              )
            }
          })
        }
      </div>
    </>
  )
}

export default SubscriptionUpgrade;